<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>权重配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-button size="mini" style="margin-left: 10px" type="primary" @click="exportJson()">导出JSON</el-button>
              <syncVersion :in-method="updateWeightCdn" />
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>方块权重配置</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload0"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importProbUploadSuccess(res, 'blocks')}"
                :headers="headers"
              >
                <el-button :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>
            <el-col :span="1.5">
              <el-button
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData('blocks')"
              >导出</el-button>
            </el-col>
            <el-col :span="1.5"> <clear-cache-apply /> <sync-data /></el-col>
            <el-col :span="1.5"><el-button type="success" size="mini" @click="onSubmit">保存</el-button></el-col>
            <el-col :span="1.5"><el-button type="primary" size="mini" icon="el-icon-plus" @click="add">新增等级</el-button></el-col>
          </el-row>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="lv" label="等级ID" width="100" />
          <el-table-column v-for="(blocksId, index) in Object.keys(blocksIdNameMap)" :key="index" :label="blocksIdNameMap[blocksId]">
            <template v-slot:default="scope">
              <div>{{ scope.row.blocks_weight.find(item => item.id == blocksId) ? blocksId : '-' }}</div>
              <div>{{ scope.row.blocks_weight.find(item => item.id == blocksId) ? scope.row.blocks_weight.find(item => item.id == blocksId).weight : '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="230">
            <template v-slot:default="scope">
              <div style="display: flex; justify-content: center; gap: 10px;">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="configVisibleArr[scope.$index].visible = true"
                >
                  编辑权重
                </el-button>
                <el-button
                  v-if="unsavedLevels.has(scope.$index)"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="removeLevel(scope.$index)"
                >
                  删除等级
                </el-button>
              </div>
              <el-drawer
                :before-close="(d)=>{return handleClose(d, scope.$index)}"
                :title="`等级 ${scope.row.lv} - 方块权重配置`"
                size="600px"
                :visible="configVisibleArr[scope.$index].visible"
              >
                <el-table :data="scope.row.blocks_weight" border size="mini">
                  <el-table-column label="方块ID">
                    <template v-slot:default="drawerScope">
                      <el-select v-model.number="drawerScope.row.id" size="mini" style="width: 100%">
                        <el-option
                          v-for="item in getAvailableOptions(scope.$index, drawerScope.$index)"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="权重" width="180">
                    <template v-slot:default="drawerScope">
                      <el-input-number v-model="drawerScope.row.weight" :min="0" :max="100" size="mini" />
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120">
                    <template v-slot:default="drawerScope">
                      <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeConfig(scope.$index, drawerScope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin-top: 20px; text-align: left;">
                  <el-button type="primary" size="mini" :disabled="!hasAvailableIds(scope.$index)" @click="addConfig(scope.$index)">添加方块</el-button>
                  <span style="margin-left: 20px;">当前数量: {{ scope.row.blocks_weight.length }}</span>
                </div>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="configVisibleArr[scope.$index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="configClick(scope.$index)">确 定</el-button>
                </div>
              </el-drawer>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
import { exportWeight, getWeightList, importWeight, updateWeight } from '@/api/config/tetris/weight'
import { getBlocksIDNameMap } from '@/api/config/tetris/blocks'
import SyncVersion from '@/components/SyncVersion/index.vue'
import { updateWeightCdn } from '@/api/config/tetris'
export default {
  name: 'TetrisBlocksWeight',
  components: { SyncData, ClearCacheApply, SyncVersion },
  data() {
    return {
      numbers: [],
      loading: false,
      configVisibleArr: [],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'lv': 0,
          'blocks_weight': [{
            'id': 0,
            'weight': 0
          }]
        }
      ],
      blocksIdNameMap: {},
      blockOptions: [],
      unsavedLevels: new Set() // 记录未保存的等级索引
    }
  },
  created() {
    this.getTables()
    this.getBlocksMap()
  },
  methods: {
    updateWeightCdn,
    onSubmit() {
      const data = JSON.stringify(this.formData)
      updateWeight({ type: 'blocks', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
          // 保存成功后清空未保存等级记录
          this.unsavedLevels.clear()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    // 删除等级
    removeLevel(index) {
      this.$confirm('确定要删除该等级配置吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.formData.splice(index, 1)
        this.unsavedLevels.delete(index)
        // 更新剩余未保存等级的索引
        const updatedUnsaved = new Set()
        this.unsavedLevels.forEach(idx => {
          if (idx > index) {
            updatedUnsaved.add(idx - 1)
          } else if (idx < index) {
            updatedUnsaved.add(idx)
          }
        })
        this.unsavedLevels = updatedUnsaved
      })
    },
    getTables() {
      this.formData = []
      const params = { ...this.queryParams, type: 'blocks' }
      getWeightList(params).then(res => {
        this.formData = res.data.list
        console.log(this.formData)
        this.total = res.data.count
        // 初始化抽屉可见性数组
        this.configVisibleArr = res.data.list.map(() => ({ visible: false }))
        // 从服务端获取的数据都是已保存的，清空未保存等级记录
        this.unsavedLevels.clear()
      })
    },
    add() {
      const lv = this.formData.length > 0 ? Math.max(...this.formData.map(item => item.lv)) + 1 : 1
      const _config = []
      // 使用blockOptions中的ID来初始化配置
      this.blockOptions.forEach(option => {
        _config.push({
          'id': option.value,
          'weight': 0
        })
      })
      // 如果没有blockOptions，默认添加前5个ID
      if (_config.length === 0) {
        for (let i = 1; i <= 5; i++) {
          _config.push({
            'id': i,
            'weight': 0
          })
        }
      }
      this.formData.push({
        lv: lv,
        blocks_weight: _config
      })
      // 更新configVisibleArr数组
      this.configVisibleArr.push({ visible: false })
      // 记录未保存的等级索引
      this.unsavedLevels.add(this.formData.length - 1)
    },
    exportData(template) {
      console.log(template)
      exportWeight({ type: template }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response, template) {
      this.loading = true
      importWeight({ data: response.data.path, type: template }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
          // 清空上传组件的文件列表
          if (this.$refs.upload0) {
            this.$refs.upload0.clearFiles()
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getBlocksMap() {
      getBlocksIDNameMap({}).then(res => {
        if (res.code === 200) {
          this.blocksIdNameMap = res.data
          // 转换为下拉选项格式
          this.blockOptions = Object.keys(res.data).map(id => ({
            value: parseInt(id),
            label: `${id} - ${res.data[id]}`
          }))
          // 根据映射长度重新初始化列数
          const mapLength = Object.keys(res.data).length
          this.numbers = []
          for (let i = 0; i < Math.min(mapLength, 30); i++) {
            this.numbers.push(i)
          }
        }
      })
    },
    handleClose(done, index) {
      this.configVisibleArr[index].visible = false
      done()
    },
    addConfig(index) {
      const selectedIds = this.formData[index].blocks_weight.map(item => item.id)
      const availableId = this.blockOptions
        .map(option => option.value)
        .find(id => !selectedIds.includes(id))
      if (!availableId) {
        this.msgError('没有可用的方块ID了，无法添加更多配置')
        return
      }
      this.formData[index].blocks_weight.push({
        'id': availableId,
        'weight': 0
      })
    },
    hasAvailableIds(index) {
      const selectedIds = this.formData[index].blocks_weight.map(item => item.id)
      return this.blockOptions.some(option => !selectedIds.includes(option.value))
    },
    removeConfig(rowIndex, configIndex) {
      if (this.formData[rowIndex].blocks_weight.length <= 1) {
        this.msgError('至少保留一个方块配置')
        return
      }
      this.formData[rowIndex].blocks_weight.splice(configIndex, 1)
    },
    configClick(index) {
      this.configVisibleArr[index].visible = false
      this.onSubmit()
    },
    getAvailableOptions(rowIndex, excludeIndex) {
      // 获取已选择的ID（排除当前行）
      const selectedIds = this.formData[rowIndex].blocks_weight
        .filter((item, index) => index !== excludeIndex)
        .map(item => item.id)
      // 过滤掉已选择的ID
      return this.blockOptions.filter(option => !selectedIds.includes(option.value))
    },
    exportJson() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/exportTetrisWeightJson')
    }
  }
}
</script>

<style scoped>
.box-card {
  padding: 10px;
}

.el-table .el-table__cell {
  padding: 8px 0;
}

.el-table--mini .el-table__cell {
  padding: 4px 0;
}
</style>
